export default __webpack_public_path__ + "static/media/fNeutral25.7173aa47.png";